import React, { useState } from 'react';
import { ChevronDown } from 'react-feather';
import type { FAQ } from '../../types';
import { motion, AnimatePresence } from 'framer-motion';
import { useAnimation } from '../../context/AnimationContext';
import { canonicalizeInternalLinks } from '../../lib/utils';

interface FaqSectionProps {
  faqs: FAQ[];
  title?: string;
  subtitle?: string;
}

const FaqSection: React.FC<FaqSectionProps> = ({ faqs, title, subtitle }) => {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const { shouldAnimate } = useAnimation();

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  if (!faqs || faqs.length === 0) {
    return null;
  }

  return (
    <div className="py-12">
        <div className="mx-auto max-w-4xl">
          {title && (
            <div className="mx-auto mb-12 text-center">
              <h2 className="text-4xl md:text-5xl font-serif font-bold">{title}</h2>
              {subtitle && <p className="mt-4 text-lg text-white/80">{subtitle}</p>}
            </div>
          )}
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="rounded-2xl border border-white/10 bg-white/5 glass-effect overflow-hidden">
                <button onClick={() => toggleFaq(index)} className="w-full flex justify-between items-center p-6 text-left">
                  <span className="text-lg font-semibold">{faq.question}</span>
                  <motion.div
                    animate={{ rotate: openFaq === index ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <ChevronDown />
                  </motion.div>
                </button>
                {shouldAnimate ? (
                  <AnimatePresence>
                  {openFaq === index && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: 'easeInOut' }}
                      className="overflow-hidden"
                    >
                      <div className="px-6 pb-6 border-t border-white/10 pt-4">
                        <p className="text-white/90" dangerouslySetInnerHTML={{ __html: canonicalizeInternalLinks(faq.answer) }}></p>
                      </div>
                    </motion.div>
                  )}
                  </AnimatePresence>
                ) : (
                  openFaq === index && (
                    <div className="overflow-hidden">
                      <div className="px-6 pb-6 border-t border-white/10 pt-4">
                        <p className="text-white/90" dangerouslySetInnerHTML={{ __html: canonicalizeInternalLinks(faq.answer) }}></p>
                      </div>
                    </div>
                  )
                )}
              </div>
            ))}
          </div>
        </div>
    </div>
  );
};

export default FaqSection;